import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { FaStar, FaRegStar } from 'react-icons/fa';
import { CONTRAST, WARNING } from '../../theme';

const IconContainer = styled.div`
  padding-right: 12px;
  cursor: pointer;
`;

const iconStyle = (isStarred) => ({
  color: isStarred ? WARNING : CONTRAST,
});

const mapState = ({ starredParcels }) => {
  return {
    starredParcels,
  };
};

export const Star = ({ parcelId }) => {
  const { starredParcels } = useSelector(mapState);
  const dispatch = useDispatch();
  const starParcel = (id) => {
    dispatch({
      type: 'STAR_PARCEL',
      payload: {
        id,
      },
    });
    dispatch({
      type: 'TRACK',
      payload: {
        name: 'Star Parcel',
        parcelId,
      },
    });
  };

  const unstarParcel = (id) => {
    dispatch({
      type: 'UNSTAR_PARCEL',
      payload: {
        id,
      },
    });
  };

  const isStarred = starredParcels.includes(parcelId);

  const onClick = (e) => {
    e.stopPropagation();
    if (isStarred) unstarParcel(parcelId);
    else starParcel(parcelId);
  };

  return (
    <IconContainer>
      {isStarred ? (
        <FaStar onClick={onClick} size={22} style={iconStyle(isStarred)} />
      ) : (
        <FaRegStar onClick={onClick} size={22} style={iconStyle(isStarred)} />
      )}
    </IconContainer>
  );
};
